import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { corporate_landing_path } from '@routes';
import { IMGIX_URL } from '@src/env';
import { ClickTarget, TrackingLocation, click } from '@tracking';

const CorporateSubscription = () => {
  const corporateHeader = `${IMGIX_URL}/global/subscribe/Corporate_Header.png`;
  const { trackEvent } = useEventTracking({ location: TrackingLocation.CorporateSubscription });

  return (
    <aside
      className="my-48 flex flex-col items-center justify-center gap-32 border-0 border-y border-solid border-grayscale-charcoal py-48 sm:px-32 md:flex-row md:justify-between md:gap-0 lg:justify-center lg:gap-80"
      data-test="corporate-subscription"
    >
      <div className="max-w-[315px]">
        <h4 className="m-0 font-suisse-works text-headline-xxs text-black">
          Corporate Subscriptions
        </h4>
        <p className="m-0 font-suisse-intl text-button-md text-grayscale-gray">
          Get a corporate subscription for your team.
        </p>
        <PrimaryButton
          as="link"
          size="small"
          href={corporate_landing_path()}
          className="mt-24 w-full"
          onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.ContactSales }))}
        >
          Contact sales
        </PrimaryButton>
      </div>
      <LazyImgixImage
        alt="Corporate Subscription Header"
        src={corporateHeader}
        sizes="600px"
        className="w-full sm:w-[460px]"
        wrapperClassName="!flex"
      />
    </aside>
  );
};

export default CorporateSubscription;
